const BASE = "/api/publishing";

export async function fetchPublishedRoster() {
  const res = await fetch(`${BASE}/roster`);
  if (!res.ok) throw new Error(`Roster fetch failed: ${res.status}`);
  return res.json();
}

export async function fetchRosterProfile(slug) {
  const res = await fetch(`${BASE}/roster/${encodeURIComponent(slug)}`);
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`Profile fetch failed: ${res.status}`);
  return res.json();
}

function authHeaders() {
  const token = sessionStorage.getItem("wp_token");
  return token
    ? { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
}

export async function fetchAdminRoster(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const res = await fetch(`${BASE}/admin/roster${qs ? `?${qs}` : ""}`, {
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`Admin roster fetch failed: ${res.status}`);
  return res.json();
}

export async function createRosterProfile(data) {
  const res = await fetch(`${BASE}/admin/roster`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(data),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.message || `Create failed: ${res.status}`);
  return json;
}

export async function updateRosterProfile(id, data) {
  const res = await fetch(`${BASE}/admin/roster/${id}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(data),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.message || `Update failed: ${res.status}`);
  return json;
}

export async function updateRosterStatus(id, status) {
  const res = await fetch(`${BASE}/admin/roster/${id}/status`, {
    method: "PATCH",
    headers: authHeaders(),
    body: JSON.stringify({ status }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.message || `Status update failed: ${res.status}`);
  return json;
}

export async function deleteRosterProfile(id) {
  const res = await fetch(`${BASE}/admin/roster/${id}`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.message || `Delete failed: ${res.status}`);
  return json;
}

export async function reorderRoster(items) {
  const res = await fetch(`${BASE}/admin/roster/reorder`, {
    method: "PATCH",
    headers: authHeaders(),
    body: JSON.stringify({ items }),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.message || `Reorder failed: ${res.status}`);
  return json;
}

export async function fetchAdminInvitations(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const res = await fetch(`${BASE}/admin/invitations${qs ? `?${qs}` : ""}`, {
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`Invitations fetch failed: ${res.status}`);
  return res.json();
}

export async function createInvitation(data) {
  const res = await fetch(`${BASE}/admin/invitations`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(data),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.message || `Invitation failed: ${res.status}`);
  return json;
}

export async function revokeInvitation(id) {
  const res = await fetch(`${BASE}/admin/invitations/${id}/revoke`, {
    method: "POST",
    headers: authHeaders(),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.message || `Revoke failed: ${res.status}`);
  return json;
}

export async function fetchAdminUsers(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const res = await fetch(`${BASE}/admin/users${qs ? `?${qs}` : ""}`, {
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error(`Users fetch failed: ${res.status}`);
  return res.json();
}
